//css generator

const tags = ["h1", "h2", "h3", "h4", "h5", "h6", "p", "div", "label", "i","em", "head", "body", "img", "video", "audio", "iframe", "canvas", "svg", "span"];

function cssGenerator(styles, parentSelector = "") {
  let mediaQuery = "";
  let CSS = "";
  Object.entries(styles).map(([selectorKey, style]) => {
    let selector = `${parentSelector} `;
    //check if subclass is main class
    if (selectorKey.includes("&")) {
      selector += selectorKey.slice(1);
    } else if (!selectorKey.includes(".") && !selectorKey.includes("#") && selectorKey !== "" && !tags.includes(selectorKey)) {
      selector += "." + selectorKey;
    } else {
      selector += selectorKey;
    }

    // render only first label style
    const tempCSS = Object.entries(style)
      .map(([key, value]) => {
        if (typeof value !== "object" || value?.top !== undefined) {
          return checkValue(key, value);
        }
      })
      .join("");

    CSS += tempCSS ? `${selector} {` + tempCSS + "}" : "";

    // generate child style
    CSS += Object.entries(style)
      .map(([key, value]) => {
        if (typeof value === "object" && value?.top === undefined) {
          if (key.includes("min:")) {
            mediaQuery += `@media screen and (min-width: ${key.replace("min:", "")}){${cssGenerator({ [""]: value }, `${selector}`)}}`;
          } else if (key.includes("max:")) {
            mediaQuery += `@media screen and (max-width: ${key.replace("max:", "")}){${cssGenerator({ [""]: value }, `${selector}`)}}`;
          } else if (key.includes("media")) {
            mediaQuery += `${key}{${cssGenerator({ [""]: value }, `${selector}`)}}`;
          } else {
            return cssGenerator({ [key]: value }, `${selector}`);
          }
        }
      })
      .join("");
  });
  return CSS + mediaQuery;
}

export default cssGenerator;

// css property generator from js to css
function cssPropertyGenerator(string) {
  let property = string.split(/(?=[A-Z])/);
  if (Array.isArray(property)) {
    return property
      .map((item) => {
        return item.toLocaleLowerCase();
      })
      .join("-");
  }

  return string;
}

export const checkValue = (k, v) => {
  let css = "";

  if (v == "" || typeof v == "undefined" || v == "undefined" || v == "url(undefined)" || v == "undefinedpx undefinedpx undefinedpx undefinedpx" || v == "undefinedpx" || v == "default" || v == " " || v == "undefinedpx !important") {
    return;
  } else {
    if (typeof v === "object") {
      css = `${cssPropertyGenerator(k)}:${v?.top || "0px"} ${v.right || "0px"} ${v.bottom || "0px"} ${v.left || "0px"};`;
    } else {
      css = `${cssPropertyGenerator(k)}:${v};`;
    }
  }
  return css;
};
